import {useState} from 'react'

import profile from '../assets/me.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faCircleArrowDown } from "@fortawesome/free-solid-svg-icons";
import {  faGithub, faLinkedinIn } from "@fortawesome/free-brands-svg-icons";
import hr from '../assets/curve-hr.svg'

export default function Hiro () {

    const [loaded, setLoaded] = useState(true);
    const [lightbox, setLightbox] = useState(false);

    return (
        <>
        {loaded ?
        <div
            className="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-white flex flex-col items-center justify-center"
        >Loading...</div>
            :
            null
        }

        {lightbox && (
            <div
                className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-80 cursor-zoom-out"
                onClick={() => setLightbox(false)}
            >
                <img
                    src={profile}
                    alt="profile enlarged"
                    className="max-h-[90vh] max-w-[90vw] rounded-2xl shadow-2xl"
                    onClick={e => e.stopPropagation()}
                />
                <button
                    className="absolute top-4 right-6 text-white text-4xl font-bold leading-none hover:text-gray-300"
                    onClick={() => setLightbox(false)}
                    aria-label="Close"
                >&times;</button>
            </div>
        )}

        <div id="home" className="flex w-full h-screen flex-col md:flex-row gap-5 items-center justify-center text-white relative">
            <div className='md:w-3/6 md:p-4 relative group'>
                <img
                    data-aos="flip-right" data-aos-duration="1500" data-aos-offset="300"
                    src={profile} alt="profile"
                    onLoad={() => setLoaded(false)}
                    onClick={() => setLightbox(true)}
                    className="cursor-zoom-in rounded-xl hover:opacity-90 transition-opacity"
                />
                <div className="absolute bottom-2 left-1/2 -translate-x-1/2 bg-black bg-opacity-60 text-white text-xs px-3 py-1 rounded-full pointer-events-none opacity-100 group-hover:opacity-0 transition-opacity duration-300 whitespace-nowrap">
                    🔍 Click to enlarge
                </div>
            </div>
            <div className='md:w-3/6' data-aos="fade-right" data-aos-duration="1000" data-aos-offset="100" >
                <div className="flex flex-col w-full mt-8">
                    <h1 className="text-xl text-gray-400">Hi, I'm</h1>
                    <h1 className="text-2xl font-bold">Bryant</h1>
                    <p className="text-xl font-bold text-gray-300">Cloud/DevOps/SRE Engineer</p>
                    <p className="text-md font-light text-gray-400 ">with 4 years of experience designing and modernising cloud infrastructure. Specialised in scalability, reliability and availability of cloud infrastructure, as well as application health observability - applying a strategic approach to problem-solving that keeps production happy and on-call rotations quiet.</p>
                    <p className="text-md font-light text-gray-400 ">A relentless upskiller who approaches certifications like Pokémon gym badge. Looking to drive operational excellence and innovation for organisations to build what's next.</p>
                </div>
                <span className='mt-2 block'>Contact Me <FontAwesomeIcon className='ml-2' icon={faCircleArrowDown}/> </span>
                    
                
                <ul className='flex mt-2 gap-4 items-center' >
                   <li>
                        <a href='https://github.com/BryantLan12138' rel="noreferrer" target="_blank"><FontAwesomeIcon size='2xl' icon={faGithub} /></a>
                   </li> 
                    
                    <li>
                        <a href='https://www.linkedin.com/in/tu-lan-4b46021b1/' rel="noreferrer" target="_blank"><FontAwesomeIcon size='2xl' icon={faLinkedinIn} /></a>
                    </li>
                </ul>
            </div>
            <img src={hr} className="w-full md:h-2 absolute bottom-0" alt="hr" />
        </div>
        </>
    )
}
